module.exports = __webpack_public_path__ + "static/enarmes-1094d8a078ddfee3815f49c4f7581647.jpg";